import { AudiencePlatformItem } from '@digiseg-labs/api-client';

const hiddenIdPlatforms = [
  'basis',
  'bidtheatre',
  'criteo',
  'openx',
  'targetspot',
  'theadx',
  'triton',
];

const normalizePlatformText = (value: string) =>
  value.toLowerCase().replace(/[^a-z0-9]+/g, '');

export const shouldHidePlatformId = (platform?: AudiencePlatformItem | null) => {
  if (!platform) return false;
  const normalized = normalizePlatformText(`${platform.code ?? ''} ${platform.display_name ?? ''}`);
  return hiddenIdPlatforms.some((token) => normalized.includes(token));
};
